
// this function define all custom style for player

import { IPlayer } from "models/player.model";
import { VideoJsPlayer } from "video.js";

export function CustomizePlayer(config: IPlayer, mediaNumber: number, player: VideoJsPlayer): void {
    let style = '';

    if (!config.control_color) {
        config.control_color = "#FFFFFF";
    }

    if (!config.controlbar_color) {
        config.controlbar_color = "#000000";
    }

    if (!config.control_active_color) {
        config.control_active_color = "#0098FF";
    }

    if (config.logo_image !== void 0 && config.logo_image !== null) {
      style += `
        .vjs-logo img {

           width: ${config.logo_percentage}% !important;
           height: ${config.logo_percentage}% !important;
        }
      `
    }

    style += `

    .vjs-control-bar {
      background-color:${config.controlbar_color}!important
    }

    .video-js .vjs-big-play-button:hover {
      background-color:${config.control_active_color} !important
    }

    .vjs-control-bar .vjs-button {
      color:${config.control_color} !important
    }

    .vjs-control-bar .vjs-button:hover {
      background-color:${config.control_active_color} !important
    }

    .vjs-marker-inn {
      background-color: ${config.control_color} !important
    }

    .no-touch .video-js .vjs-button {
      background-color: ${config.control_color} !important
    }

    .vjs-control-bar .vjs-load-progress {
      background-color: ${convertColorToRGB(config.control_active_color, 0.5)} !important
    }

    .video-js .vjs-progress-control .vjs-play-progress {
      border-radius: 4px;
      background-color:${convertColorToRGB(config.control_active_color, 1)} !important
    }

    .video-js .vjs-volume-level {
      background-color: ${convertColorToRGB(config.control_active_color, 1)} !important
    }
  `

    // controls button display

    if (!config.show_controls) {
      player.getChild('controlBar')?.el().remove();
    }

    if (!config.show_audio) {
      player.getChild('controlBar').getChild('volumePanel').el().remove()
    }

    if (!config.enable_embed_code) {
        style += `
        .embed-code { display: none !important; }`;
    }

    if (!config.show_duration) {
      player.getChild('controlBar').getChild('currentTimeDisplay')?.el()?.remove();
      player.getChild('controlBar').getChild('durationDisplay')?.el()?.remove();
    }

    if (!config.show_fullscreen) {
      player.getChild('controlBar').getChild('fullscreenToggle')?.el()?.remove();
    }


    style += `
    .vjs-info {
       padding: 40px 24px !important;
       background: linear-gradient(0deg, transparent, rgb(106 110 114 / 40%));
      }
    `


    if (!config.show_progression) {
      player.getChild('controlBar')?.getChild('progressControl')?.el().remove();
    }

    if (!config.show_speed) {
        style += `
        .vjs-extend-speed { display: none !important; }`;
    }

    if (!config.show_replay) {
        style += `
        .vjs-replay-button { display: none !important; }`;
        style += `
        .vjs-play-control.vjs-ended { display: none !important; }`;
    }

    const head = document.head || document.getElementsByTagName("head")[0];
    const styleNode = document.createElement("style");

    styleNode.innerHTML = style;
    head.appendChild(styleNode);
}

function convertColorToRGB(color: string, opacity: number): string | null {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
    return result
        ? `rgba(
      ${parseInt(result[1], 16)},
      ${parseInt(result[2], 16)},
      ${parseInt(result[3], 16)},
      ${opacity})`
        : null;
}
